import { render } from "./SelectDropdown.molecule.vue?vue&type=template&id=735a0952&bindings={\"options\":\"props\",\"modelValue\":\"props\",\"isOpen\":\"setup\",\"isSelected\":\"setup\",\"closeDropdown\":\"setup\",\"toggleDropdown\":\"setup\",\"onSelectValue\":\"setup\"}"
import script from "./SelectDropdown.molecule.vue?vue&type=script&lang=ts"
export * from "./SelectDropdown.molecule.vue?vue&type=script&lang=ts"
script.render = render

export default script